// @ts-strict-ignore
import { isAfter, parseISO } from 'date-fns';

import { ApplicantProfile } from 'api/applicantProfile';
import { CurrentUser } from 'api/currentUser';
import { isNonAdmin } from 'utils/currentUser';
import { isDefined } from 'utils/functional';
import {
  NOTIFICATIONS,
  dismissNotification,
  notificationIsDismissed,
} from 'utils/localNotifications';
import { getItem } from 'utils/localStorage';

const NEW_USER_DATE = new Date('2020-11-16T17:00:00Z');
export const dismissResumeDBLoggedOut = () =>
  dismissNotification(NOTIFICATIONS.UPLOAD_RESUME);
export const hasResumeDb = (user: CurrentUser) =>
  getItem('enableResumeDb') !== false &&
  (user.isUS || user.isRecruitable) &&
  CURRENT_LOCALE === 'en';
export const hasWorkHistoryJobs = (profile?: ApplicantProfile) =>
  profile && profile.workHistoryJobs && profile.workHistoryJobs.length > 0;
export const promoteResumeDatabase = ({
  currentUser,
  includeDate,
  allowLoggedOut,
}: {
  currentUser: CurrentUser;
  includeDate?: boolean;
  allowLoggedOut?: boolean;
}) =>
  hasResumeDb(currentUser) &&
  !notificationIsDismissed(NOTIFICATIONS.UPLOAD_RESUME) &&
  ((allowLoggedOut && currentUser && !currentUser.id) ||
    (isNonAdmin(currentUser) &&
      (!isDefined(currentUser.isRecruitable) ||
        (currentUser.isRecruitable && !currentUser.resumeId)))) &&
  (!includeDate || isAfter(parseISO(currentUser.created), NEW_USER_DATE));
